import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4o95d3k7hq: FaireBrandEntity = {
  token: "b_4o95d3k7hq",
  type: "brand",
  name: "BUCKETLIST INC",
  avatarUrl:
    "https://cdn.faire.com/fastly/7b2fa39138a3f26005360c56947754a82eeca8e48e76702bb290aec7ee9d4c5f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2e653c9386be21149386e7d4dbc9e244074650ab6a0e7bce4214b750e89dc405.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7b2fa39138a3f26005360c56947754a82eeca8e48e76702bb290aec7ee9d4c5f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2e653c9386be21149386e7d4dbc9e244074650ab6a0e7bce4214b750e89dc405.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 90,
  rating: 4.6,
  reviewCount: 845,
  isInsider: true,
  description:
    "Bucketlist is a women's young contemporary wholesale clothing line that's designed for all ages and built to last in your closet from season to season. We want our line to be trendy but wearable and be your favorite staple piece in your closet.\nEach collection is produced with the utmost attention to hues, prints, fabrics and silhouettes.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:26.061Z",
    importedBy: "entity-db-cli",
  },
};
